// angular
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../../../app.service';
import * as moment from 'moment';

@Component({
    selector: 'me-appointment-booked-card',
    templateUrl: './booked-card.component.html',
    styleUrls: ['./booked-card.component.scss'],
})

export class MeAppointmentBookedCardComponent implements OnInit {
    data: any;
    url = 'appointment/booked-card';
    replaceText;

    @Input() meetingTime;
    @Input() meetingUrl;

    constructor(
        public translate: TranslateService,
        public appService: AppService
    ) {
       
    }

    ngOnInit() {
        this.getBookedCard();

        this.translate.onLangChange.subscribe(res => {
            this.getBookedCard();
        });
    }

    getBookedCard() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content'] ?? [];
            this.data = contents;
            this.getText();
            this.appService.isLoading = false;
        });
    }

    getText() {
        this.translate.get('at').subscribe(value => {
            let locale = this.translate.currentLang.split('_')[0];
            let day = moment(this.meetingTime).locale(locale).format('dddd, MMMM DD, YYYY');
            let minute = moment(this.meetingTime).locale(locale).format('HH:mm');
            this.replaceText = {
                start : day + ' ' + value + ' ' + minute
            };
        });
    }

    joinAppointment(){
        window.open(this.meetingUrl);
    }
}
